import { Capacitor } from "@capacitor/core";
import { isMobile as isMobileBrowser } from "react-device-detect";

/**
 * Check if QR code login is enabled
 */
export const isQRCodeLoginEnabled =
  import.meta.env.VITE_QR_CODE_LOGIN === "true";

/**
 * Check if the gamepad vibration panel is enabled
 */
export const isVibrationCheckEnabled =
  import.meta.env.VITE_VIBRATION_CHECK === "true";

const targetPlatform = import.meta.env.VITE_TARGET_PLATFORM;

// TODO: add check is TizenOS, WebOS...
export const isTV =
  window.AndroidBridge?.isTV() ||
  targetPlatform === "webos" ||
  targetPlatform === "tizen";

export const isTizen = targetPlatform === "tizen";
export const isWebos = targetPlatform === "webos";
export const isAndroidAppTv = window.AndroidBridge?.isTV();

export const isFireTv =
  typeof navigator !== "undefined" && /\bAFT[A-Z0-9]/.test(navigator.userAgent);
export const isAndroidApp = Capacitor.isNativePlatform() && !isTV;
export const isNativeApp = Capacitor.isNativePlatform();

export const isIOS =
  typeof navigator !== "undefined" &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));

export const isIOSPhone = /iPhone|iPod/.test(navigator.userAgent);

export const isIpad = isIOS && !isIOSPhone;

export const isTalkBackEnabled = () =>
  window.AndroidBridge?.isTalkBackEnabled() ?? false;

export type Platform =
  | "lg"
  | "samsung"
  | "android-tv"
  | "android-mobile"
  | "mobile-web"
  | "pc-web";

export const getCurrentAppPlatform = (): Platform => {
  if (isWebos) return "lg";
  if (isTizen) return "samsung";
  if (isAndroidAppTv) return "android-tv";
  if (isAndroidApp || isNativeApp) return "android-mobile";
  return isMobileBrowser ? "mobile-web" : "pc-web";
};
